import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Shell } from "@/components/Shell";
import { STAFF_ROLES, STAFF_QUESTIONS } from "@/data/staff";
import { upsertStaff } from "@/lib/storage";

export default function StaffStartPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [role, setRole] = useState("");

  const start = (e) => {
    e.preventDefault();
    if (!name.trim() || !role) return;
    const entry = upsertStaff(id, { id: crypto.randomUUID(), name: name.trim(), role, createdAt: new Date().toISOString(), status: "draft", answers: {} });
    if (entry) navigate(`/staff/${id}/${entry.id}`);
  };

  return (
    <Shell>
      <form onSubmit={start} className="card p-7 sm:p-10 fade-up">
        <p className="eyebrow">Voce dello staff</p>
        <h1 className="font-serif text-3xl sm:text-4xl font-bold text-[#2C221E] mt-2">Chi risponde?</h1>
        <p className="text-[#5C4D46] mt-3">{STAFF_QUESTIONS.length} domande, cinque minuti. Le risposte servono a confrontare il punto di vista di chi lavora con quello dei titolari.</p>
        <label className="block mt-8">
          <span className="eyebrow">Nome</span>
          <input autoFocus className="field mt-2 text-lg" placeholder="es. Luca" value={name} onChange={(e) => setName(e.target.value)} data-testid="input-staff-name" />
        </label>
        <p className="eyebrow mt-6 mb-2">Ruolo</p>
        <div className="grid gap-3 sm:grid-cols-2">
          {STAFF_ROLES.map((r, i) => (
            <button key={r} type="button" className="choice" data-selected={role === r} onClick={() => setRole(r)} data-testid={`staff-role-${i}`}>
              <span className="choice-mark" />{r}
            </button>
          ))}
        </div>
        <div className="flex flex-wrap gap-3 mt-8 justify-between">
          <button type="button" className="btn btn-ghost" onClick={() => navigate(`/risultato/${id}`)} data-testid="staff-back-btn"><ArrowLeft size={18} /> Indietro</button>
          <button type="submit" className="btn btn-primary" disabled={!name.trim() || !role} data-testid="start-staff-survey-btn">Inizia <ArrowRight size={18} /></button>
        </div>
      </form>
    </Shell>
  );
}
